		$(window).on("resize load",function(){
			var w = $(window).width();
			var x = 1200;
			if (w <= x) {
				var NEKOKKE = NEKOKKE || {};
				NEKOKKE.VIEW_HEIGHT = {
					init : function(){
						this.setParameters();
						this.setKvHeight();
						this.bind();
					},
					setParameters : function(){
						this.$window = $(window);
						this.$target = $('.main_box');
					},
					bind : function(){
						var _self = this;
						this.$window.on('resize',function(){
							_self.setKvHeight();
						});
					},
					setKvHeight : function(){
						this.$target.css('height',this.$window.height());
					}
				};
				$(function(){
					NEKOKKE.VIEW_HEIGHT.init();
				});
			}
		});